<template>
  <main class="html-page exams-page">
    <section class="page-hero exams-hero" data-bloco="exames-hero" data-tipo="hero">
      <div class="container exams-hero-grid">
        <div class="exams-hero-copy">
          <p class="eyebrow" v-html="html(examesHero, 'iti_nome')"></p>
          <h1 data-campo="iti_resumo1" v-html="html(examesHero, 'iti_resumo1')"></h1>
          <p data-campo="iti_descricao1" v-html="html(examesHero, 'iti_descricao1')"></p>
        </div>
        <div class="exams-hero-media"><img v-if="image(examesHero)" alt="Diagnóstico veterinário por imagem"
            :src="image(examesHero)" @error="hideBrokenImage"></div>
      </div>
    </section>
    <section class="section exams-browser" data-bloco="exames-menu" data-tipo="lista">
      <div class="container exams-layout">
        <aside class="exam-side" data-repetidor="exames-menu" aria-label="Selecione um exame"><button
            v-for="(item, index) in examesMenu" :key="item.itiId || index" class="exam-tab"
            :class="{ active: selectedExamIndex === index }" type="button" @click="selectExam(index)"><img v-if="icon(item)"
              alt="" :src="icon(item)" @error="hideBrokenImage"><span v-html="html(item, 'iti_nome')"></span></button>
        </aside>
        <div class="exam-panels" data-bloco="exames-modal" data-tipo="conteudo">
          <article v-if="selectedExam" class="exam-panel active">
            <div class="exam-detail">
              <p class="eyebrow" v-html="html(selectedExam, 'iti_referencia')"></p>
              <h2 v-html="html(selectedExam, 'iti_nome')"></h2>
              <p v-html="html(selectedExam, 'iti_descricao2')"></p>
              <div class="hero-actions"><a v-if="link(selectedExam, 'iti_link_btn1')" class="btn btn-primary"
                  :href="link(selectedExam, 'iti_link_btn1')" v-html="html(selectedExam, 'iti_texto_btn1')"></a><a
                  v-if="link(selectedExam, 'iti_link_btn2')" class="btn btn-light"
                  :href="link(selectedExam, 'iti_link_btn2')" v-html="html(selectedExam, 'iti_texto_btn2')"></a></div>
            </div>
            <div class="exam-photo-slider">
              <figure v-for="(photo, index) in selectedGallery" :key="photo + index"
                :class="{ active: selectedPhotoIndex === index }"><img :src="photo" :alt="text(selectedExam, 'iti_nome')"
                  @error="hideBrokenImage"></figure><button v-if="selectedGallery.length > 1" class="exam-arrow prev"
                type="button" aria-label="Foto anterior" @click="previousExamPhoto">‹</button><button
                v-if="selectedGallery.length > 1" class="exam-arrow next" type="button" aria-label="Próxima foto"
                @click="nextExamPhoto">›</button>
              <div v-if="selectedGallery.length > 1" class="exam-dots" aria-label="Navegação das fotos"><button
                  v-for="(_, index) in selectedGallery" :key="index" type="button"
                  :class="{ active: selectedPhotoIndex === index }" :aria-label="'Mostrar foto ' + (index + 1)"
                  @click="goExamPhoto(index)"></button></div>
            </div>
          </article>
        </div>
      </div>
    </section>
    <a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
  </main>
</template>

<script>
import {
  contentValue,
  firstImage,
  imageByGallery,
  imagesByGallery,
  gridItems,
  loadScreens,
  normalizeInternalLink,
  applyPageMeta,
} from '@/services/contentApi';

export default {
  name: 'ExamesView',
  data() {
    return {
      examesHero: {},
      examesMenu: [],
      examesModal: {},
      selectedExamIndex: 0,
      selectedPhotoIndex: 0,
      heroSlide: 0,
      carouselSlide: 0,
      carouselTimer: null,
    };
  },
  computed: {
    selectedExam() {
      return this.examesMenu[this.selectedExamIndex] || this.examesMenu[0] || null;
    },
    selectedGallery() {
      const photos = imagesByGallery(this.selectedExam, 'Galeria');
      return photos;
    },
  },
  created() {
    this.loadContent();
  },
  watch: {
    '$route.query.exame'() {
      this.selectExamFromRoute();
      this.applyMeta(this.$route.query.exame ? this.selectedExam : this.examesHero);
    },
  },
  mounted() {
    this.carouselTimer = window.setInterval(() => {
      this.nextExamPhoto();
    }, 5500);
  },
  beforeUnmount() {
    if (this.carouselTimer) window.clearInterval(this.carouselTimer);
  },
  methods: {
    selectExamFromRoute() {
      const id = String(this.$route.query.exame || '');
      if (!id) return;
      const index = this.examesMenu.findIndex((item) => String(item.itiId ?? item.iti_id ?? '') === id);
      if (index >= 0) this.selectExam(index);
    },
    text(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source) { return firstImage(source); },
    icon(source) { return imageByGallery(source, 'Icone'); },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    bg(source) {
      const url = firstImage(source);
      return url ? { backgroundImage: 'url("' + url + '")' } : {};
    },
    grids(source) {
      return gridItems(source);
    },
    link(source, field, fallback = '') {
      return normalizeInternalLink(contentValue(source, field, fallback), fallback);
    },
    applyMeta(source) {
      applyPageMeta({
        title: contentValue(source, 'iti_nome'),
        description: contentValue(source, 'iti_resumo1') || contentValue(source, 'iti_descricao1'),
        image: firstImage(source) || this.selectedGallery[0] || '',
      });
    },
    selectExam(index) {
      this.selectedExamIndex = index;
      this.selectedPhotoIndex = 0;
      this.$nextTick(() => this.applyMeta(this.selectedExam));
    },
    nextExamPhoto() {
      const total = this.selectedGallery.length;
      if (total > 1) this.selectedPhotoIndex = (this.selectedPhotoIndex + 1) % total;
    },
    previousExamPhoto() {
      const total = this.selectedGallery.length;
      if (total > 1) this.selectedPhotoIndex = (this.selectedPhotoIndex - 1 + total) % total;
    },
    goExamPhoto(index) {
      this.selectedPhotoIndex = index;
    },
    async loadContent() {
      const data = await loadScreens([
        {
          ctiId: 20,
          key: "examesHero",
          multi: false,
        },
        {
          ctiId: 21,
          key: "examesMenu",
          multi: true,
        },
        {
          ctiId: 22,
          key: "examesModal",
          multi: false,
        },
      ]);

      Object.assign(this, data);
      this.selectExamFromRoute();
      this.applyMeta(this.$route.query.exame ? this.selectedExam : this.examesHero);
    },
  },
};
</script>
